module.exports = __webpack_public_path__ + "img/w3_circle_down_light.97d88c11.97d88c11.png";